import { supabase } from './api'

export async function getAllData() {
	const { data, error } = await supabase.from('goalstrackerfollow').select()

	if (error) {
		throw new Error('Failed to fetch data', error)
	}

	return data
}

export async function getGoalStrackerIdData(gtid) {
	const { data, error } = await supabase.from('goalstrackerfollow').select().eq('gtid', gtid)

	if (error) {
		throw new Error('Failed to fetch data: ' + error.message)
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('goalstrackerfollow').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('goalstrackerfollow').update(udata).eq('id', udata.id).select()
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('goalstrackerfollow').delete().eq('id', id)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
